import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "asset-history-container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "asset-history-filters" }
const _hoisted_6 = { class: "d-flex flex-row flex-wrap gap-2 filter-controls" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "quick-range-buttons" }
const _hoisted_9 = { class: "quick-range-label" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "errors" }
const _hoisted_12 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_13 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_14 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_15 = { class: "visually-hidden" }
const _hoisted_16 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_17 = {
  key: 2,
  class: "history-chart-wrapper"
}
const _hoisted_18 = { class: "chart-buttons-floating" }
const _hoisted_19 = { class: "series-table-wrapper" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "badge rounded-pill bg-primary fw-semibold" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "badge rounded-pill bg-info text-white fw-semibold" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "badge rounded-pill bg-danger fw-semibold" }
const _hoisted_26 = { class: "visibility-cell" }
const _hoisted_27 = { class: "form-check form-switch m-0" }
const _hoisted_28 = ["onUpdate:modelValue", "onChange"]
const _hoisted_29 = {
  key: 3,
  class: "text-center text-muted py-5"
}
const _hoisted_30 = { class: "chart-buttons-floating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", null, [
            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-clock-history" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDetails.historyTitle')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                class: "flex-grow",
                placeholder: _ctx.$t('components.datepicker.startPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitStartDate
              }, null, 8, ["modelValue", "placeholder", "onEmitDate"]),
              _createVNode(_component_date_picker, {
                modelValue: _ctx.endDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
                class: "flex-grow",
                placeholder: _ctx.$t('components.datepicker.endPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitEndDate
              }, null, 8, ["modelValue", "placeholder", "onEmitDate"]),
              (!_ctx.isSearching)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success btn-search",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchHistory && _ctx.searchHistory(...args)))
                  }, _toDisplayString(_ctx.$t('components.search')), 1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-success btn-search btn-search-disabled",
                    title: _ctx.$t('components.history.tooltip'),
                    "data-bs-toggle": "tooltip",
                    disabled: ""
                  }, _toDisplayString(_ctx.$t('components.search')), 9, _hoisted_7))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('components.assetDetails.quickRangeLabel')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangePresets, (preset) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: preset.key,
                  type: "button",
                  class: _normalizeClass(["btn btn-light btn-sm", { active: _ctx.activePreset === preset.key }]),
                  onClick: ($event: any) => (_ctx.applyPreset(preset.key))
                }, _toDisplayString(_ctx.$t(preset.label)), 11, _hoisted_10))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.filterError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.filterError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                ])
              ]))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
                ]))
              : (_ctx.chartHasData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (!_ctx.isChartFullscreen)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["chart-container", { 'dark-mode': _ctx.isDarkMode }])
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", {
                              class: "btn btn-custom",
                              type: "button",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openChartFullscreen && _ctx.openChartFullscreen(...args))),
                              title: "Pełny ekran"
                            }, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
                            ]))]),
                            _createElementVNode("button", {
                              class: "btn btn-custom",
                              type: "button",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetChartZoom && _ctx.resetChartZoom(...args))),
                              title: "Reset zoom"
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                            ]))]),
                            _createElementVNode("button", {
                              class: "btn btn-custom chart-action-export",
                              type: "button",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportToPng && _ctx.exportToPng(...args))),
                              title: "Eksport PNG"
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                            ]))]),
                            _createElementVNode("button", {
                              class: "btn btn-custom chart-action-export",
                              type: "button",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exportToJpg && _ctx.exportToJpg(...args))),
                              title: "Eksport JPG"
                            }, [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                            ]))]),
                            _createElementVNode("button", {
                              class: "btn btn-custom chart-action-export",
                              type: "button",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args))),
                              title: "Eksport CSV"
                            }, [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                            ]))])
                          ]),
                          (_openBlock(), _createBlock(_component_LineChart, {
                            ref: "historyChart",
                            key: _ctx.chartRenderKey,
                            height: 550,
                            "chart-id": _ctx.chartId,
                            "chart-data": _ctx.chartData,
                            options: _ctx.chartOptions,
                            plugins: _ctx.chartPlugins
                          }, null, 8, ["chart-id", "chart-data", "options", "plugins"]))
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_DxDataGrid, {
                        class: "series-grid",
                        "data-source": _ctx.seriesStats,
                        "show-borders": false,
                        "row-alternation-enabled": true,
                        "column-auto-width": true,
                        "column-hiding-enabled": true,
                        "hover-state-enabled": false
                      }, {
                        "min-chip": _withCtx(({ data }) => [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(data.data.min), 1)
                          ])
                        ]),
                        "avg-chip": _withCtx(({ data }) => [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(data.data.avg), 1)
                          ])
                        ]),
                        "max-chip": _withCtx(({ data }) => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(data.data.max), 1)
                          ])
                        ]),
                        "visibility-cell": _withCtx(({ data }) => [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((data.data.visible) = $event),
                                class: "form-check-input",
                                type: "checkbox",
                                role: "switch",
                                onChange: ($event: any) => (_ctx.toggleSeriesVisibility(data.data))
                              }, null, 40, _hoisted_28), [
                                [_vModelCheckbox, data.data.visible]
                              ])
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_DxColumn, {
                            "data-field": "visible",
                            caption: _ctx.$t('components.assetDetails.seriesTable.visible'),
                            "cell-template": "visibility-cell",
                            "allow-sorting": false,
                            "allow-filtering": false,
                            alignment: "center"
                          }, null, 8, ["caption"]),
                          _createVNode(_component_DxColumn, {
                            "data-field": "label",
                            caption: _ctx.$t('components.assetDetails.seriesTable.series'),
                            alignment: "center"
                          }, null, 8, ["caption"]),
                          _createVNode(_component_DxColumn, {
                            "data-field": "min",
                            caption: _ctx.$t('components.assetDetails.seriesTable.min'),
                            "cell-template": "min-chip",
                            alignment: "center"
                          }, null, 8, ["caption"]),
                          _createVNode(_component_DxColumn, {
                            "data-field": "avg",
                            caption: _ctx.$t('components.assetDetails.seriesTable.avg'),
                            "cell-template": "avg-chip",
                            alignment: "center"
                          }, null, 8, ["caption"]),
                          _createVNode(_component_DxColumn, {
                            "data-field": "max",
                            caption: _ctx.$t('components.assetDetails.seriesTable.max'),
                            "cell-template": "max-chip",
                            alignment: "center"
                          }, null, 8, ["caption"])
                        ]),
                        _: 1
                      }, 8, ["data-source"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-bar-chart" }, null, -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.assetDetails.noHistory')), 1)
                  ]))
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isChartFullscreen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["chart-fullscreen-overlay", { 'dark-mode': _ctx.isDarkMode }]),
            onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args)), ["self"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["chart-container chart-container-fullscreen", { 'dark-mode': _ctx.isDarkMode }])
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn btn-custom",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args))),
                  title: "Zamknij"
                }, [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-custom",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetChartZoom && _ctx.resetChartZoom(...args))),
                  title: "Reset zoom"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-custom chart-action-export",
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.exportToPng && _ctx.exportToPng(...args))),
                  title: "Eksport PNG"
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-custom chart-action-export",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.exportToJpg && _ctx.exportToJpg(...args))),
                  title: "Eksport JPG"
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-custom chart-action-export",
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args))),
                  title: "Eksport CSV"
                }, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                ]))])
              ]),
              (_openBlock(), _createBlock(_component_LineChart, {
                ref: "historyChart",
                key: _ctx.chartRenderKey,
                height: _ctx.fullscreenChartHeight,
                "chart-id": _ctx.chartId,
                "chart-data": _ctx.chartData,
                options: _ctx.chartOptions,
                plugins: _ctx.chartPlugins
              }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}